export default __webpack_public_path__ + "static/illu_team-12cee5228737839e9bec0f7709ebd5dd.png";